var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      'sidebar-group-expanded': _vm.collapse
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: 'page-dropdown-' + _vm.id,
      expression: "'page-dropdown-' + id"
    }],
    staticClass: "nav-link nav-link-group d-flex align-items-center justify-content-between",
    class: {
      active: _vm.subIsActive,
      'locked-group': _vm.disabled
    },
    attrs: {
      "aria-label": _vm.title
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center nav-link-group-content"
  }, [_c('span', {
    staticClass: "menu-icon"
  }, [_c('svg-icon', {
    class: _vm.iconClass,
    attrs: {
      "name": _vm.icon,
      "viewBox": _vm.viewBox
    }
  })], 1), _c('div', {
    staticClass: "menu-title-container"
  }, [_c('span', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm.disabled ? _c('svg-icon', {
    staticClass: "static-on-hover locked-icon",
    attrs: {
      "name": "lock",
      "size": "20",
      "viewBox": "0 0 24 24"
    }
  }) : _c('svg-icon', {
    staticClass: "chevron-icon",
    class: {
      rotate: _vm.collapse
    },
    attrs: {
      "size": "20",
      "viewBox": "0 0 20 20",
      "name": "chevron-down",
      "variant": "gray"
    }
  })], 1), !_vm.lockedItem ? _c('b-collapse', {
    attrs: {
      "id": 'page-dropdown-' + _vm.id,
      "accordion": "sidebar-accordion"
    },
    model: {
      value: _vm.collapse,
      callback: function ($$v) {
        _vm.collapse = $$v;
      },
      expression: "collapse"
    }
  }, [_c('div', {
    staticClass: "group-expanded-container"
  }, _vm._l(_vm.children, function (item) {
    return _c('SidebarSimpleItem', {
      key: item.$ID,
      staticClass: "group-expanded-item",
      attrs: {
        "id": item.$ID,
        "title": _vm.$t(item.Caption),
        "icon": item.Icon,
        "icon-class": item.IconClass,
        "view-box": item.ViewBox,
        "router-to": _vm.destination(item),
        "ability": item.ability,
        "show-lock": item.showLock
      }
    });
  }), 1)]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };